import SeoHead from '../../components/SeoHead';
import { Global, Jobs, Collection } from '@sourceflow-uk/sourceflow-sdk';
import React from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from 'next/link';
import SubBanner from '../../components/SubBanner';
import TextWithCTA from '../../components/TextWithCTA';
import Clients from '../../components/Clients';
import OurValues from '../../components/OurValues';
import WhyDrivingForce from '../../components/WhyDrivingForce';
import LatestJobs from '../../components/LatestJobs';
import Header from '../../components/MainHeader';
import TabTestimonial from '../../components/TabTestimonial';
import SimplePage from '../../components/SimplePage';
import AllClientsByJobSearch from '../../components/AllClientsByJobSearch';

export default function JobSearchbyClient({
    global,
    all_clients,
    all_jobs,
    all_jobseeker_tag_testimonial,
    all_temporary_testimonials,
    all_permanent_testimonials,
    all_jobs_search_by_client
}) {
    return (
        <>
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`Job search by client | Gap Personnel`}
                // description={``}
                canonical_link={`/job-search-by-client/`}
            />
            <Header
                employerNav={false}
            />
            <SubBanner
                global={global}
                pathPrefix={`job_search_by_client_page.sub_banner`}
                customClass={`mb-5 secondary-banner`}
                buttonTitle={`Jobseekers`}
                buttonLink={`/job-seekers/`}
                heading={`Job search by client`}
                bannerImage="/site-assets/images/jobseeker-contact.jpg"
                bannerImageAlt="Jobseekers Job search by client"

            />
            <TextWithCTA
                global={global}
                pathPrefix={`job_search_by_client_page.text_with_cta`}
                customClass={`mt-5 mb-5 pb-lg-5`}
                link1={`/job-seekers-get-in-touch`}
                link2={`/recruit-staff/`}
                column1={true}
                column2={false}
                buttonTitle1={
                    <>
                        <strong>
                            Get a callback
                        </strong> and we'll help you find your next role
                    </>
                }
                buttonTitle2={
                    <>
                        <strong>
                            Recruit staff
                        </strong> let us help your fill your next role
                    </>
                }
                fullWidth={true}
                mainButtonTitle1={`Get in touch`}
                mainButtonLink1={`/job-seekers-get-in-touch/`}
            />
            <AllClientsByJobSearch
                global={global}
                pathPrefix={`job_search_by_client_page.all_clients_by_job_search`}
                customClass='text-center mb-5 pb-5'
                post={all_jobs_search_by_client}
                content={
                    <p>Search for jobs by client below or click <Link href="/jobs/">here</Link> to browse all jobs.
                    </p>
                }
            />
            <OurValues
                global={global}
                pathPrefix={`job_search_by_client_page.our_values`}
                customClass='mb-5 secondaryColor'
                sub_heading_1={`Consultative`}
                sub_heading_2={`Accountable`}
                sub_heading_3={`Real`}
                sub_heading_4={`Ethical`}
                sub_heading_5={``}
                content_1={`It’s right there in the job title, ‘Recruitment Consultant’. We want to understand exactly what you’re looking for in your next role; your salary expectations, where you can travel to, shift patterns that will work for you. Only by consulting with you can we find you a role that fits your wants and needs.`}
                content_2={`If we say we’ll do it, then we’ll do it. Got a query? If we don’t already have the answer we’ll find out and get back to you. Is something not quite working out with your job role? We want to know so we can try and resolve it.`}
                content_3={`We want to get to know you so we can support you personally. By being approachable and responsive we will build a real relationship with you so we can have open and honest conversations.`}
                content_4={`We have lots of compliance processes in place to safeguard the welfare of our workers, but more it’s more than that - we promise to always be totally transparent. You’ll know every detail of any placement on offer before you agree to it, and if it’s not for you there’ll be no pressure from us.`}
                content_5={``}
                heading={`Our Values`}
                imageSrc1={`/site-assets/images/consultative-icon.jpg`}
                imageSrc2={`/site-assets/images/accountable-icon.jpg`}
                imageSrc3={`/site-assets/images/real-icon.jpg`}
                imageSrc4={`/site-assets/images/ethical-icon.jpg`}
                imageSrc5={``}
                imageAlt1={`Consultative`}
                imageAlt2={`Accountable`}
                imageAlt3={`Real`}
                imageAlt4={`Ethical`}
                imageAlt5={``}
                displayOnDefault={true}
            />
            <Clients
                global={global}
                pathPrefix={`job_search_by_client_page.all_clients`}
                all_clients={all_clients}
                customClass={`pt-lg-5 mt-lg-5`}
                heading={`Accreditations and partnerships`}
            />
            {/* <SimplePage
                global={global}
                pathPrefix={`job_seeker_page.simple_page`}
                customClass={`mt-5 pt-5 mb-5 pb-5 pb-md-0`}
                content={
                    <>
                        <h2>Talk to us about Driver CPC training</h2>
                        <p>We’re a fully qualified driving school able to support you through your initial and ongoing periodic training. You can find out more <Link href="/job-seekers-specialisms/cpc-training/"><a className
                            ="text-decoration-none">here</a></Link>.</p>
                    </>
                }
                textCenter={true}
            /> */}
            {/* <WhyDrivingForce
                global={global}
                pathPrefix={`job_search_by_client_page.why_driving_force`}
                customClass='mt-5 mb-5 pt-lg-5 pb-5 secondaryColor'
                formId={`2b1903d0-c09a-4b34-9c3b-27a7b7afb573`}
                heading={`Why jobseekers choose Driving Force`}
                all_testimonials={all_jobseeker_tag_testimonial}
                subheading={`Get in touch`}
                column2={false}
                fullWidthColumn={true}
                TestimonialCardColumn2={true}
                TestimonialCardfullWithColumn={false}
                testimonialCardCustomClass={`testimonial-only`}
            />
            <TabTestimonial
                global={global}
                pathPrefix={`job_search_by_client_page.tab_testimonial`}
                customClass={`mb-5 pb-5 secondary-bg-color`}
                heading={
                    <>
                        <div className='mb-5'>
                            <h5>
                                What are you waiting for?
                            </h5>
                            <p>Working together to find your perfect driving job is as easy as 1 2 3.</p>
                        </div>
                    </>
                }
                content={``}
                column1Text={`Looking for a temporary placement?`}
                column2Text={`or`}
                column3Text={`Looking for a permanent placement?`}
                testimonial1={all_temporary_testimonials}
                testimonial2={all_permanent_testimonials}
                postOrder={true}
            />
            <LatestJobs
                global={global}
                pathPrefix={`job_search_by_client_page.latest_jobs`}
                customClass={`mt-3 mb-5 pb-5`}
                buttonTitle={`view all jobs`}
                buttonLink={`/jobs/`}
                heading={`Find work that suits you`}
                subtitle={`jobseekers`}
                all_jobs={all_jobs}
                label={false}
            /> */}
        </>
    );
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const clients = await Collection('accreditations');
    const jobs_search_by_client = await Collection('client_landing_page');

    const all_jobs = (await Jobs())
        .filter(function (job) {
            return (
                (new Date(job?.expires_at)) >= (new Date())
            )
        })
        .getItems().slice(0, 8);

    const all_clients = clients.orderBy('order').getItems();
    const all_jobs_search_by_client = jobs_search_by_client.orderBy('order').getItems();

    //Testimonials Tag
    const jobseekerTag = "Jobseekers";
    const temporaryTag = "Temporary";
    const permanentTag = "Permanent";


    const jobseeker_tag_testimonial = (await Collection('testimonials'))
        .filter(function (post) {
            return (
                post.tag?.en === jobseekerTag
            );
        })
    const temporary_testimonials = (await Collection('testimonials'))
        .filter(function (post) {
            return (
                post.tag?.en === temporaryTag
            );
        })

    const permanent_testimonials = (await Collection('testimonials'))
        .filter(function (post) {
            return (
                post.tag?.en === permanentTag
            );
        });
    const all_jobseeker_tag_testimonial = jobseeker_tag_testimonial.orderBy('order').getItems();
    const all_temporary_testimonials = temporary_testimonials.orderBy('order').getItems();
    const all_permanent_testimonials = permanent_testimonials.orderBy('order').getItems();

    return {
        props: {
            global,
            all_clients,
            all_jobs,
            all_jobseeker_tag_testimonial,
            all_temporary_testimonials,
            all_permanent_testimonials,
            all_jobs_search_by_client
        },
    }
}